module.exports = __webpack_public_path__ + "img/less.2e5d197b.svg";